import React, { useState } from 'react';
import { TagIcon } from '@heroicons/react/24/outline';
import { Budget } from '../types/budget';
import { EntitiesManagementDialog } from './EntitiesManagementDialog';

interface EntitiesManagementButtonProps {
  budget: Budget;
  showText?: boolean;
  className?: string;
}

export const EntitiesManagementButton: React.FC<EntitiesManagementButtonProps> = ({
  budget,
  showText = true,
  className = '',
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const baseClasses =
    'flex items-center rounded-md bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:bg-indigo-500 dark:hover:bg-indigo-600 dark:focus:ring-indigo-400';
  const buttonClasses = className ? `${baseClasses} ${className}` : baseClasses;

  return (
    <>
      <button
        onClick={() => setIsDialogOpen(true)}
        className={buttonClasses}
        title="Gérer les catégories et responsables"
      >
        <TagIcon className={`h-5 w-5 ${showText ? 'mr-2' : ''}`} />
        {showText && <span>Gérer catégories</span>}
      </button>

      <EntitiesManagementDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        budget={budget}
      />
    </>
  );
};
